import { useSessionOrderEventCleanup } from 'store/trips/use-session-order-event-cleanup'

import {
  CreateTripProvider,
  type TripFormMode,
} from 'pages/trip/create-trip/create-trip-context'
import CreateTripContent from 'pages/trip/create-trip/create-trip-content'

type CreateCarrierTripDialogProps = {
  open: boolean
  onClose: () => void
  mode?: TripFormMode
  editingTripId?: number
  onSaved?: () => void
}

const CreateCarrierTripDialog = ({
  open,
  onClose,
  mode = 'create',
  editingTripId,
  onSaved,
}: CreateCarrierTripDialogProps) => {
  const { cancelTripCreation } = useSessionOrderEventCleanup()

  const handleExit = async () => {
    await cancelTripCreation()
    onClose()
  }

  if (!open) return null

  return (
    <CreateTripProvider
      onExit={handleExit}
      variant="carrier"
      mode={mode}
      editingTripId={editingTripId}
      onSaved={onSaved}
    >
      <CreateTripContent />
    </CreateTripProvider>
  )
}

export default CreateCarrierTripDialog
